import { render, staticRenderFns } from "./PaginateBlock.vue?vue&type=template&id=3abd11f9"
import script from "./PaginateBlock.vue?vue&type=script&lang=js"
export * from "./PaginateBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports